import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Logs = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Logs
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          System logs coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Logs;